<template>
  <div>
    <div ref="myEcharts" :style="{'width':width,'height':height}"></div>
  </div>
</template>

<script>
import echarts from 'echarts'

 export default {
  name: 'circleEcherts',
  components: {
    
  },
  props:{
    echartsData:{
        type:Object
    },
    width:{

    },
    height:{

    }
  },
  data() {
    return {
        echartsStr:'',
        echartsStr_data:'',
    }
  },
  watch: {
    echartsData:{
        handler(n,v){
           
            if(n){
                this.echartsStr_data = n;
                console.log(n);
                this.$nextTick(()=>{
                    this.getEchats()
                })
                
            }
        },
        // 该回调将会在侦听开始之后被立即调用
      immediate: true,
      //该回调会在任何被侦听的对象的 property 改变时被调用，不论其被嵌套多深
      deep: true
    }
  },
  mounted() {
    const _this = this
    window.addEventListener('resize', function () {
            console.log('改变了');
            _this.echartsStr.resize()
    })      
  },
  created() {},
  methods: {
    getEchats(){
        console.log(this.$refs);
        this.echartsStr = this.$echarts.init(this.$refs.myEcharts);
        let option = {
                    color: [
                        "#00FFFF",
                        "#00B0FF",
                        "#FFC000",
                        "#FFAB6F",
                        "#63E315",
                        "#893BFF",
                    ],
                    legend: {
                        orient: "vertical",
                        left: "1%",
                        top: "1%",
                        itemHeight: 12, //图例的高度
                        itemGap: 15, //图例之间的间距
                        textStyle: { // 图例的公用文本样式。
                        color: 'white',
                        fontSize: this.nowSize(12)
                    },
                        data: [
                            {
                                name: this.echartsStr_data.titleOne,
                                icon: "circle",
                                textStyle: {
                                    color: "#D2D3D8", // 单独设置某一个图列的颜色
                                },
                            },
                            {
                                name:  this.echartsStr_data.titleTwo,
                                icon: "circle",
                                textStyle: {
                                    color: "#D2D3D8", // 单独设置某一个图列的颜色
                                },
                            },
                            {
                                name:this.echartsStr_data.titleThree,
                                icon: "circle",
                                textStyle: {
                                    color: "#D2D3D8", // 单独设置某一个图列的颜色
                                },
                            },
                          
                        ],
                        //图例的名字需要和饼图的name一致，才会显示图例
                    },
                    series: [
                        // A版块
                        {
                            name:this.echartsStr_data.titleOne,
                            type: "pie",
                            right: '5%',
                            bottom:'1%',
                            radius: ["61%", "70%"],
                            center: ["50%", "65%"],
                            
                            //环的位置
                            label: {
                                show: false,
                                position: "center",
                            },
                            labelLine: {
                                normal: {
                                    show: false,
                                },
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: this.nowSize(20),
                                    fontWeight: "bold",
                                },
                            },
                            data: [
                                {
                                    value: this.echartsStr_data.ytsdFive, //需要显示的数据
                                    name:Math.round((this.echartsStr_data.ytsdFive / this.echartsStr_data.ytsdSix*100))+ "%",
                                    itemStyle: {
                                        normal: {
                                            color: "#00FFFF",
                                        },
                                    },
                                },
                                {
                                    value: this.echartsStr_data.ytsdSix - this.echartsStr_data.ytsdFive,
                                    //不需要显示的数据，颜色设置成和背景一样
                                    itemStyle: {
                                        normal: {
                                            color: "#081A3C",
                                        },
                                    },
                                },
                            ],
                        },
                        // B版块
                        {
                            name: this.echartsStr_data.titleTwo,
                            type: "pie",
                            radius: ["51%", "60%"],
                            center: ["50%", "65%"],
                            right: '5%',
                            bottom:'1%',
                            //环的位置
                            label: {
                                show: false,
                                position: "center",
                            },
                            labelLine: {
                                normal: {
                                    show: false,
                                },
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: "20",
                                    fontWeight: "500",
                                },
                            },
                            data: [
                                {
                                    value: this.echartsStr_data.ytsdThree, //需要显示的数据
                                    name: Math.round((this.echartsStr_data.ytsdThree / this.echartsStr_data.ytsdFour)*100) + "%",
                                    itemStyle: {
                                        normal: {
                                            color: "#00B0FF",
                                        },
                                    },
                                },
                                {
                                    value: this.echartsStr_data.ytsdFour - this.echartsStr_data.ytsdThree,
                                    //不需要显示的数据，颜色设置成和背景一样
                                    itemStyle: {
                                        normal: {
                                            color: "#081A3C",
                                        },
                                    },
                                },
                            ],
                        },
                        // C版块
                        {
                            name: this.echartsStr_data.titleThree,
                            type: "pie",
                            radius: ["35%", "50%"],
                            center: ["50%", "65%"],
                            right: '5%',
                            bottom:'1%',
                            //环的位置
                            label: {
                                show: false,
                                position: "center",
                            },
                            labelLine: {
                                normal: {
                                    show: false,
                                },
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: "20",
                                    fontWeight: "bold",
                                },
                                itemStyle: {
                                    normal: {
                                        color: "#FFC000",
                                    },
                                },
                            },
                            data: [
                                {
                                    value: this.echartsStr_data.ytsdOne, //需要显示的数据
                                    name: Math.round((this.echartsStr_data.ytsdOne / this.echartsStr_data.ytsdTwo)*100)  + "%",
                                    itemStyle: {
                                        normal: {
                                            color: "#FFC000",
                                        },
                                    },
                                },
                                {
                                    value: this.echartsStr_data.ytsdTwo - this.echartsStr_data.ytsdOne,
                                    //不需要显示的数据，颜色设置成和背景一样
                                    itemStyle: {
                                        normal: {
                                            color: "#081A3C",
                                        },
                                    },
                                },
                            ],
                        },
                    
                    ],
                };
                this.echartsStr.setOption(option);
    },
     //  换算方法
     nowSize(val, initWidth = 1920) {
            //当前视口宽度
            let nowClientWidth = document.documentElement.clientWidth;

            return val * (nowClientWidth / initWidth);
        },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/circleEcherts/circleEcherts.vue